import {ChosenObject} from 'src/pages/camera-config/components/object-detection/components/stepperModal/StepperModal'
import {BarrierType} from '../../../services/api/endpoints/ObjectEndpoint'

export class CreateObjectDTO {
  confidence: number
  isActive: boolean
  objectTypeId: number
  threshold: number
  type: BarrierType

  interestAreaId?: number
  isObjectCounting?: boolean

  detectionsOptionsSelected?: Array<string>

  maximumTime?: number
  isObjectPermanency?: boolean

  constructor(chosenObject: ChosenObject) {
    this.confidence = chosenObject.confidence
    this.isActive = chosenObject.isActive
    this.threshold = chosenObject.threshold
    this.objectTypeId = chosenObject.objectTypeId
    this.type = chosenObject.type
    this.interestAreaId = chosenObject.interestAreaId
    this.isObjectCounting = chosenObject.isObjectCounting
    this.maximumTime = chosenObject.maximumTime
    this.isObjectPermanency = chosenObject.isObjectPermanency
    this.detectionsOptionsSelected = chosenObject.detectionsOptionsSelected
  }
}

export class CreateSpeedDetectionObject extends CreateObjectDTO {
  distance?: number
  cameraId?: number
  speedLimit?: number
  interestAreaId: number

  constructor(chosenObject: ChosenObject, interestAreaId: number) {
    super(chosenObject)
    this.distance = chosenObject.distance
    this.cameraId = chosenObject.cameraId
    this.speedLimit = chosenObject.speedLimit
    this.interestAreaId = interestAreaId
  }
}

export class EditObjectDTO {
  id?: number
  confidence?: number
  isActive?: boolean
  threshold?: number
  maximumTime?: number

  detectionsOptionsSelected?: Array<string>

  constructor(chosenObject: ChosenObject) {
    this.id = chosenObject.id
    this.confidence = chosenObject.confidence
    this.isActive = chosenObject.isActive
    this.threshold = chosenObject.threshold
    this.maximumTime = chosenObject.maximumTime
    this.detectionsOptionsSelected = chosenObject.detectionsOptionsSelected
  }
}

export class EditSpeedDetectionObject extends EditObjectDTO {
  speedObject?: {distance?: number; speedLimit?: number; id?: number}

  constructor(chosenObject: ChosenObject) {
    super(chosenObject)
    this.speedObject = {
      distance: chosenObject.distance,
      speedLimit: chosenObject.speedLimit,
      id: chosenObject.speedObjectId,
    }
  }
}
